(function () {
  var PAGE = 3;

  function bindPager(root) {
    var size = parseInt(root.getAttribute('data-fp-page-size') || String(PAGE), 10) || PAGE;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-fp-review]'));
    var pager = root.querySelector('[data-fp-pager]');
    if (!items.length || !pager) return;

    var pages = Math.ceil(items.length / size);
    var current = 1;
    var nums = pager.querySelector('[data-fp-pager-pages]');
    var nextBtn = pager.querySelector('[data-fp-next]');
    var lastBtn = pager.querySelector('[data-fp-last]');

    function renderNumbers() {
      if (!nums) return;
      nums.textContent = '';
      for (var i = 1; i <= pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = String(i);
        btn.setAttribute('data-fp-goto', String(i));
        btn.setAttribute('aria-label', 'Page ' + i);
        if (i === current) btn.setAttribute('aria-current', 'page');
        nums.appendChild(btn);
      }
    }

    function show(page) {
      current = Math.max(1, Math.min(pages, page));
      items.forEach(function (el, index) {
        var itemPage = Math.floor(index / size) + 1;
        el.hidden = itemPage !== current;
      });
      renderNumbers();
      var atEnd = current >= pages;
      if (nextBtn) nextBtn.disabled = atEnd;
      if (lastBtn) lastBtn.disabled = atEnd;
    }

    pager.addEventListener('click', function (event) {
      var btn = event.target.closest('button');
      if (!btn || !pager.contains(btn)) return;
      if (btn.hasAttribute('data-fp-next')) show(current + 1);
      else if (btn.hasAttribute('data-fp-last')) show(pages);
      else if (btn.hasAttribute('data-fp-goto')) show(parseInt(btn.getAttribute('data-fp-goto'), 10));
    });

    if (pages <= 1) {
      pager.hidden = true;
      items.forEach(function (el) {
        el.hidden = false;
      });
      return;
    }

    pager.hidden = false;
    show(1);
  }

  function bindWrite() {
    document.querySelectorAll('[data-fp-write-review]').forEach(function (btn) {
      if (btn.dataset.fpBound) return;
      btn.dataset.fpBound = '1';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var host = document.querySelector('.fp-jdgm-host, .judgeme-product-reviews');
        var native =
          (host &&
            host.querySelector(
              '.jm-action-buttons__button, .jm-button.jm-button--primary, a.jdgm-write-rev-link, .jdgm-write-rev-link'
            )) ||
          document.querySelector(
            '.jm-action-buttons__button, a.jdgm-write-rev-link, .jdgm-write-rev-link'
          );
        if (native) native.click();
      });
    });
  }

  function killReviewLightbox() {
    document.querySelectorAll('.jdgm-review-widget-modal:not(.jdgm-write-review-modal)').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('.jdgm-review-widget-modal__overlay, .jm-modal-overlay').forEach(function (el) {
      if (!el.closest('.jdgm-write-review-modal')) el.remove();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('[data-fp-write-review], .fp-write-review-btn, .fp-rev-pager, .jdgm-write-review-modal, .fp-product-rating, .judgeme-star-rating')) {
        return;
      }
      var review = target.closest('.fp-review, .jdgm-rev, .jdgm-carousel-item, .jm-review');
      if (!review) return;
      if (target.closest('a[href]:not([href="#"])')) return;
      event.preventDefault();
      event.stopPropagation();
      killReviewLightbox();
    },
    true
  );

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!(node instanceof Element)) continue;
        if (node.matches('.jdgm-review-widget-modal:not(.jdgm-write-review-modal)')) node.remove();
      }
    }
  }).observe(document.body, { childList: true });

  function reviewsTarget() {
    return document.getElementById('product-reviews') || document.querySelector('[data-fp-reviews]');
  }

  function scrollToReviews(dest) {
    if (!dest) return;
    var headerVar = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')
    );
    var headerBox = document.getElementById('header-group');
    var offset = (headerVar || (headerBox ? headerBox.getBoundingClientRect().height : 0) || 0) + 16;
    var desktop = window.matchMedia('(min-width: 990px)').matches;
    var scroller = desktop ? document.querySelector('.page-wrapper') : document.scrollingElement;
    if (!scroller || !desktop) {
      dest.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var current = scroller.scrollTop || 0;
    var top = current + dest.getBoundingClientRect().top - scroller.getBoundingClientRect().top - offset;
    scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var link = target.closest(
        '.fp-product-rating, .judgeme-star-rating a, a[href="#product-reviews"], a[href="#reviews"], a[href$="/#reviews"]'
      );
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var id = href.indexOf('#') >= 0 ? href.split('#')[1] : 'product-reviews';
      var dest = (id && document.getElementById(id)) || reviewsTarget();
      if (!dest) return;
      event.preventDefault();
      event.stopPropagation();
      var drawer = document.querySelector('header-drawer, menu-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      scrollToReviews(dest);
      if (history.replaceState) history.replaceState(null, '', '#' + dest.id);
    },
    true
  );

  document.querySelectorAll('[data-fp-reviews]').forEach(bindPager);
  bindWrite();
  killReviewLightbox();
})();
